import { Capacitor } from "@capacitor/core";

// Single source of truth for the backend origin.
//
// WHY: the native iOS/Android bundle is built on a laptop where
// frontend/.env contains the PREVIEW url — CRA bakes that string in at
// build time, silently pointing the shipped app at the preview database
// (this happened with app v1.0.0). Native builds must NEVER depend on
// whatever .env happens to be on the build machine, so inside the
// Capacitor shell we hard-lock to the production origin. Web builds keep
// using the env exactly as before (preview in preview, prod on deploy).
const PRODUCTION_ORIGIN = "https://thetrucktrackr.com";

export const BACKEND_BASE = Capacitor.isNativePlatform()
  ? PRODUCTION_ORIGIN
  : process.env.REACT_APP_BACKEND_URL || "";

// Public web origin for share/copy links. In the native app
// window.location.origin is capacitor://localhost — never shareable.
export const PUBLIC_WEB_ORIGIN = Capacitor.isNativePlatform()
  ? PRODUCTION_ORIGIN
  : (typeof window !== "undefined" ? window.location.origin : PRODUCTION_ORIGIN);
